import { Button, Card, CardBody, CardHeader, Spinner, Switch } from "@heroui/react"
import { ShieldCheckIcon } from "@heroicons/react/24/outline"
import PropTypes from "prop-types"

const TeacherPermissions = ({ handleSave, handleUpdate, isDirty, isLoading, isSaving, settings }) => (
  <Card className="mt-3">
    <CardHeader className="justify-between text-white bg-indigo-700">
      <div className="flex items-center">
        <ShieldCheckIcon className="mr-2 w-14 h-14" />
        <div className="flex flex-col mr-8">
          <h1 className="text-lg font-semibold">Teacher Permissions</h1>
          <p className="text-sm">Control teachers access in the system.</p>
        </div>
      </div>

      <Button color="success" isDisabled={!isDirty || isLoading} isLoading={isSaving} className="font-semibold text-white" onPress={() => handleSave()}>Save</Button>
    </CardHeader>

    <CardBody>
      <div className="px-4 pb-3 border-gray-200 border-dotted border-b-1">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-semibold">Allow Bookings &amp; Cancellations</h3>
            <p className="text-content2-foreground">Allow teachers to make bookings and cancellations on behalf of parents.</p>
          </div>
        
          {isLoading && <Spinner className="ml-8" />}
        
          {!isLoading && (
            <Switch 
              color="success" 
              isSelected={settings.allow_teacher_bookings} 
              onValueChange={(value) => handleUpdate('allow_teacher_bookings', value)} aria-label="Allow bookings" 
            />
          )}        
        </div>
      </div>

      <div className="px-4 py-3 border-gray-200 border-dotted border-b-1">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-semibold">Allow Availability Selector</h3>
            <p className="text-content2-foreground">Allow teachers to determine their availability.</p>
          </div>
          
          {isLoading && <Spinner className="ml-8" />}
          
          {!isLoading && (
            <Switch 
              color="success" 
              isSelected={settings.allow_teacher_availability} 
              onValueChange={(value) => handleUpdate('allow_teacher_availability', value)} aria-label="Allow availability selector" 
            />          
          )}
        </div>
      </div>

      <div className="px-4 py-3">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-semibold">Allow Reports</h3>
            <p className="text-content2-foreground">Allow access to the reports section for teachers.</p>
          </div>

          {isLoading && <Spinner className="ml-8" />}

          {!isLoading && (
            <Switch 
              color="success" 
              isSelected={settings.allow_teacher_reports} 
              onValueChange={(value) => handleUpdate('allow_teacher_reports', value)} aria-label="Allow availability selector" 
            />  
          )}
        </div>
      </div>
    </CardBody>
  </Card>
)

TeacherPermissions.propTypes = {
  handleSave: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  isDirty: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSaving: PropTypes.bool,
  settings: PropTypes.shape({
    allow_teacher_bookings: PropTypes.bool,
    allow_teacher_availability: PropTypes.bool,
    allow_teacher_reports: PropTypes.bool,
  }),
}

export default TeacherPermissions